import { render } from "./AdminPlans.vue?vue&type=template&id=4d97148c&scoped=true"
import script from "./AdminPlans.vue?vue&type=script&lang=js"
export * from "./AdminPlans.vue?vue&type=script&lang=js"

import "./AdminPlans.vue?vue&type=style&index=0&id=4d97148c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d97148c"]])

export default __exports__